import React, { useEffect, useState } from "react";
import * as image from "../../resources/images";
import LessonContentRIght from "./LessonContentRIght";
import CharacterContent from "./CharacterContent";
import { ShimmerCategoryList } from "react-shimmer-effects";
import DeletePlanActivities from "../learnerplan/DeletePlanActivities";
import { ViewVideo } from "../dimensions/activity";
import LessonModuleCallengeRightpanel from "../dimensions/course/social/LessonModuleCallengeRightpanel";
import NewmodulelessonRightPane from "./NewmodulelessonRightPane";
import { useDispatch, useSelector } from "react-redux";
import { SITEURLNAME } from "../../utils/Messages";
import SctModule from "./SctModule";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getPlanUserCourse, getSocialActivityDetail } from "../../redux/actions/APIs";
const CourseDetailRightPaenl = ({ userPoint, getTab, currentSceneObj, handleIsNext, getMyActivity, loginType, isBlink, getCount, currentCourse, setTab }) => {
    const params = useParams();
    const dispatch = useDispatch();
    const {
            loggedInUser,
            defaultChildData,
            sctReflectionResp,
        } = useSelector((state) => state.collections);

    const [deletePlan, setDeletePlan] = useState();
    const [showVideoPopUp, setShowVideoPopUp] = useState(false);
    const [videoData, setVideoData] = useState();
     const [selectedOPtion, setSelectedOPtion] = useState("");

    const closePlan = () => {
        setDeletePlan();
    }
    const handleClose = () => {
        setShowVideoPopUp(false);
    }
    const handleVideoData = (data) => {
        setVideoData(data);
    }

    const handleTab = (type)=>{
        setTab(type)
    }

    const takeAChallenge = (type)=>{
        handleTab(type);
        dispatch(getSocialActivityDetail(loggedInUser?.id, defaultChildData?.id, params?.courseId, params?.activityId));
    }

    useEffect(()=>{
            window.scrollTo(0, 0);
        },[getTab, selectedOPtion])
    

    // console.log("isBlink @ : ", isBlink);

    return (
        <>
            <div className="rightpannel">
                {currentSceneObj ? (
                    <>
                        <div className="panneltitles flexone">
                            <div className="contenttitle w-100">
                                {getTab === "Lessons" && (
                                    currentSceneObj?.kc?.length === 0 ? (
                                        <h3 className=" flexone h-3">{currentSceneObj?.rptitle}  
                                        <div className="ml-3 mypoints flexthree">
                                            <img src={image.point_bag} alt="pointbag" />
                                            <span key={Math.random()} className={`pointsno p1 ${isBlink && "pointzoomin"}`}>{loginType ? userPoint : 0}</span>
                                        </div>
                                        </h3>

                                    ) : currentSceneObj?.kc?.length > 0 && (
                                        <>
                                            {getMyActivity?.secScCount === currentSceneObj?.sequence ? (
                                                <h3 className=" flexone">Exercise  <div className="ml-3 mypoints flexthree">
                                                    <img src={image.point_bag} alt="pointbag" />
                                                    <span className={`pointsno p1 ${isBlink && "pointzoomin"}`}>{loginType ? userPoint : 0}</span>
                                                </div></h3>
                                            ) : (
                                                <h3 className="flexone">Knowledge Check  <div className="ml-3 mypoints flexthree">
                                                    <img src={image.point_bag} alt="pointbag" />
                                                    <span className={`pointsno p1 ${isBlink && "pointzoomin"}`}>{loginType ? userPoint : 0}</span>
                                                </div></h3>
                                            )}
                                            
                                        </>
                                    )
                                    
                                )}
                                {getTab === "Characters" && (
                                    <h3>Meet The Characters </h3>
                                )}
                                {getTab === "Challenges" && (
                                    <h3 className=" flexone">
                                        <span>
                                            {" "}
                                            {/* <img src={image.module_challenge} className="mr-2" alt="" /> */}
                                            Module Challenge
                                        </span>
                                    </h3>
                                )}

                                {getTab === "Reflection" && (
                                        <h3 className=" flexone">
                                             {/* {selectedOPtion ? selectedOPtion?.followUpType ? selectedOPtion?.followUpType : sctReflectionResp?.objectName : sctReflectionResp?.records[0]?.title} */}
                                             {sctReflectionResp?.records?.length > 0 &&  sctReflectionResp?.records[0]?.title  
                                                                                        ? sctReflectionResp?.records[0]?.title 
                                                                                        : sctReflectionResp?.objectName
                                                }
                                            <div className="ml-3 mypoints flexthree">
                                                    <img src={image.point_bag} alt="pointbag" />
                                                    <span className={`pointsno p1 ${isBlink && "pointzoomin"}`}>{loginType ? userPoint : 0}</span>
                                                </div></h3>
                                )}
                                
                        

                            </div>
                        </div>
                        <div className="rightpanelContent">

                        {getTab === "Lessons" ? (
                            <>
                                
                                     <LessonContentRIght
                                        currentSceneObj={currentSceneObj}
                                        handleIsNext={handleIsNext}
                                        loginType={loginType}
                                        getMyActivity={getMyActivity}
                                        getCount={getCount}
                                        handleTab={handleTab}
                                    />
                               
                                
                            </>
                           
                        ) : getTab === "Reflection" ? (
                             <SctModule 
                                        getMyActivity={getMyActivity}
                                        takeAChallenge={takeAChallenge}
                                        selectedOPtion={selectedOPtion}
                                        setSelectedOPtion={setSelectedOPtion}
                                   />
                        ) :  getTab === "Characters" ? (
                            <CharacterContent getMyActivity={getMyActivity} />
                        ) : (
                            <>
                                {/* {window.location.hostname === SITEURLNAME.urlName ? (
                                    <LessonModuleCallengeRightpanel
                                        setDeletePlan={setDeletePlan}
                                        setShowVideoPopUp={setShowVideoPopUp}
                                        handleVideoData={handleVideoData}  
                                    />
                                ) : (
                                        <NewmodulelessonRightPane 
                                                 getMyActivity={getMyActivity}
                                                setDeletePlan={setDeletePlan}
                                                
                                            />
                                )} */}
                                <NewmodulelessonRightPane 
                                    getMyActivity={getMyActivity}
                                    setDeletePlan={setDeletePlan}   
                                    currentCourse={currentCourse}                                 
                                />
                            </>
                            
                        )}
                        </div>
                    </>
                ) : (
                    <ShimmerCategoryList items={3} categoryStyle="STYLE_SIX" />
                )}
            </div>
            {deletePlan && (
                <DeletePlanActivities
                    closePlan={closePlan}
                    deletePlan={deletePlan}
                />
            )}
            {showVideoPopUp && <ViewVideo close={handleClose} data={videoData} />}
        </>
    );
}
export default CourseDetailRightPaenl;
